import { Trans } from '@lingui/react/macro';
import { useMemo } from 'react';

import { PlainButton } from '@/components/buttons';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/DropdownMenu';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/Tooltip';

import type { RuleEntityAttributeType, RuleEntityType } from './types';

type Props = {
  ruleEntity: RuleEntityType;
  isHidden?: boolean;
  previouslyUsed?: string[];
  onSelect: (attribute: RuleEntityAttributeType) => void;
  disabled?: boolean;
};

const RuleEntityAttributeDropdown = ({
  ruleEntity,
  isHidden,
  previouslyUsed,
  onSelect,
  disabled = false,
}: Props) => {
  const availableAttributes = useMemo(() => {
    return ruleEntity.attributes.filter((attribute) => !previouslyUsed?.includes(attribute.id));
  }, [ruleEntity, previouslyUsed]);

  return (
    <Tooltip disableHoverablePopup>
      <TooltipTrigger
        delay={1750}
        render={
          <DropdownMenu>
            <DropdownMenuTrigger
              disabled={disabled}
              render={
                <PlainButton
                  color="green"
                  size="small"
                  isQuiet
                  style={{ opacity: isHidden ? 0 : 1 }}
                >
                  <Trans>+ where</Trans>
                </PlainButton>
              }
            />
            <DropdownMenuContent className="min-w-40">
              {availableAttributes.map((attribute) => (
                <DropdownMenuItem key={attribute.id} onClick={() => onSelect(attribute)}>
                  {attribute.name}
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        }
      />
      <TooltipContent side="top">
        <Trans>Add a condition</Trans>
      </TooltipContent>
    </Tooltip>
  );
};

export default RuleEntityAttributeDropdown;
